import React, { ReactNode } from 'react';
import './pageSectionContent.module.scss';
import { AnchorButton } from '@sheinc/shelikes-design-system';

type Attribute = {
  text: string;
  href: string;
  testid?: string;
};

type Props = {
  image?: string;
  body: string | ReactNode;
  buttonAttributes?: Attribute[];
};

export const PageSectionContent = ({ image, body, buttonAttributes }: Props) => {
  return (
    <div styleName="page-section-content">
      {image && (
        <div styleName="page-section-content-image">
          <img styleName="page-section-content-image" src={image} />
        </div>
      )}
      <div styleName="page-section-content-body">{body}</div>
      {buttonAttributes !== undefined && (
        <div styleName="button-wrapper">
          {buttonAttributes.map((button, index) => {
            return (
              <AnchorButton key={index} variant="secondary" href={button.href} target="_blank" testId={button.testid}>
                {button.text}
              </AnchorButton>
            );
          })}
        </div>
      )}
    </div>
  );
};
